const REPORTED_VIDEOS_INITIAL_STATE = {
	reportedVideos: [],
};

export default REPORTED_VIDEOS_INITIAL_STATE;
